import { AvatarImage } from './AvatarImage';
import { useSave, useServices } from '@/ui/services/ServicesContext';

/** The player's current avatar (HUD, Menu, S20). */
export function PlayerAvatar({ size }: { size: number }) {
  const { content } = useServices();
  const avatar = useSave((s) => s.avatar);
  const tint = content.cosmetics.avatarParts.find((p) => p.id === avatar.shirtColor)?.tint ?? '#FFF8EE';
  return <AvatarImage avatar={avatar} tint={tint} size={size} />;
}
